var render = function render(){var _vm=this,_c=_vm._self._c;return _c('node-view-wrapper',{staticClass:"row-view",attrs:{"as":"tr","data-xbrl-id":_vm.node.attrs.xbrlId}},[_c('node-view-content',{staticClass:"node-content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }